import $ from 'jquery';
import Backbone from 'backbone';
import ProductThumbnail from '@component/product-thumbnail/src/views/mcom/ProductThumbnail';
import colorSwatchTpl from '@component/product-thumbnail/src/templates/partials/component-product-thumbnail/ColorSwatchTemplate.hbs';
import { ArrowIconSize } from '@component/carousel';
import ProductColorSwatch from '@component/product-thumbnail/src/ProductColorSwatch';
import template from '../templates/partials/custom-product-thumbnail.hbs';
import Constants from '../util/Constants';
import { createCarouselView } from '../util/CustomCarouselTypeDecider';
import Util from '../util/Util';

module.exports = ProductThumbnail.extend({
  template,

  onRender() {
    const properties = this.options.model.get('properties');
    if (properties.prosThumbnailRedesignTreatmentAEnabled) {
      this.$el.find('.pdpreviews').remove();
    }
  },

  getSwatchesSizeOptions() {
    // this calc is fixed for Desktop resolution as color swatches only shows in desktop mode
    const options = {
      swatchesWidth: this.el.offsetWidth,
      swatchesButtonWidth: Constants.CAROUSEL_SWATCHES_BUTTON_WIDTH,
    };

    const desktopItemPadding = 30;
    const carouselOrientation = this.options.model.get('carouselOrientation');

    if (carouselOrientation === Constants.CAROUSEL_TYPE.HORIZONTAL) {
      options.swatchesWidth = Constants.RESPONSIVE_PROS_WIDTH.LARGE - desktopItemPadding;
      options.swatchesPadding = Constants.CAROUSEL_ITEM_TOTAL_PADDING.LARGE;
    }

    return options;
  },

  getCarouselBreakpoint() {
    return Constants.SHOW_CAROUSEL_BREAKPOINT;
  },

  createSwatchCarousel(swatchHolder, swatches) {
    const collection = new Backbone.Collection(swatches);
    const swatchesSizeOpts = this.getSwatchesSizeOptions();

    const carouselItems = collection.map(model => new ProductColorSwatch({ model }).render().$el.get(0));
    // TODO: handle childwidth dynamically
    const opts = Object.assign(
      swatchesSizeOpts,
      {
        el: swatchHolder,
        childrenView: carouselItems,
        carouselOrientation: this.options.model.get('carouselOrientation'),
        carouselType: Constants.CAROUSEL_TYPE.COLORSWATCHES,
        arrowIconSize: ArrowIconSize.LARGE,
        childWidth: 35,
      },
      this.options.config,
    );

    const swatchCarousel = createCarouselView(opts.carouselType, opts);
    swatchCarousel.render();
    return swatchCarousel;
  },

  buildProductColorSwatch(traits, detail) {
    // build color swatch
    // products with a single color in the map will not build out swatches
    if (traits && traits.colors && traits.colors.colorMap && (traits.colors.colorMap.length > 0)) {
      this.buildColorSwatch(traits, detail);
    }
  },

  carouselSwatchImage(traits) {
    const swatches = traits.colors.colorMap;

    if (!swatches || Util.isMobile()) { return; }

    // render color swatch in a carousel if swatches more than 5
    const swatchHolder = this.$el.find('.colorSwatchesContainer')[0];

    if (swatches.length > this.getCarouselBreakpoint()) {
      $(swatchHolder).empty();
      this.createSwatchCarousel(swatchHolder, swatches);
      $('.productDescription').addClass('itemDetails');
    } else if (swatches.length > 1) {
      traits.colors.noCarousel = true; // eslint-disable-line no-param-reassign
      $(swatchHolder).html(colorSwatchTpl(traits));
    }

    this.toggleJumboSwatch();
  },

  toggleJumboSwatch() {
    const swatchProductId = this.$el.find('.colorSwatchesContainer').data('colorswatchproduct');
    const swatchSelected = this.$el.find('.colorSwatchesContainer').find('.swatchSelected');
    const jumboSwatchUrl = swatchSelected.data('jumboswatchurl');
    const jumboswatchOffset = swatchSelected.data('jumboswatchoffset');
    if (jumboSwatchUrl && jumboswatchOffset) {
      this.showHideJumboSwatch(swatchProductId, jumboSwatchUrl, jumboswatchOffset, true);
    }
  },

  showHideJumboSwatch(productId, url, offset, visibility) {
    const jumboSwatch = this.$el.find(`#jumboSwatch_${productId}`);
    if (visibility) {
      jumboSwatch.parent('.jumboSwatch').show();
      jumboSwatch.css('background', `url(${url})${offset}px 0 transparent`);
    } else {
      jumboSwatch.parent('.jumboSwatch').hide();
      jumboSwatch.css('background', '');
    }
  },

});
